/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            backgroundColor: 'black',
            color: 'white'
        },
        drawerHeader: {
            paddingTop: 0,
            paddingBottom: 0
        },
        icon: {
            color: 'white',
            width: 5,
            height: 5
        },
        logo: {
            width: '8.125rem',
            height: '1.4375rem'
        },
        logoContainer: {
            backgroundColor: 'yellow.400',
            borderRadius: 0,
            height: '3.125rem',
            paddingLeft: 4,
            paddingRight: 4
        },
        actions: {
            paddingLeft: 4,
            paddingRight: 4
        },
        actionsItem: {
            paddingTop: 3,
            paddingBottom: 3
        },
        localeSelector: {
            paddingTop: 1,
            paddingBottom: 1
        },
        signout: {
            width: '100%',
            paddingLeft: 0,
            paddingTop: 2,
            paddingBottom: 2,
            _focus: {
                borderRadius: 0,
                boxShadow: 'outline'
            }
        },
        signoutText: {
            marginLeft: 2,
            fontSize: 16,
            fontWeight: 400
        }
    },
    parts: [
        'actions',
        'actionsItem',
        'container',
        'logoContainer',
        'icon',
        'localeSelector',
        'signout'
    ]
}
